/** D-212: "Support · Privacy" under the front door and sign-in, and anywhere a public way out to them helps. */
import type { ReactElement } from "react";
import { TextLink } from "./Link";

export function LegalLinks(): ReactElement {
  return (
    <nav className="legal-links" aria-label="Help and privacy">
      <TextLink secondary to="/support">Support</TextLink>
      <TextLink secondary to="/privacy">Privacy</TextLink>
    </nav>
  );
}
